<template>
	<div :class="`formulate-date-selector formulate-input-element formulate-input-element--${context.type}`">
		<input type="text" :value="uiDate" @click="onDateClick">
		<div class="date-selector__icon"  @click="onDateClick">
			<img :src="getAssetPath('date--loblolly.svg', 'icons')" alt="date-picker" />
		</div>
		<EditDateOverlay
			ref="editDateOverlay"
			overlayTitle="Datum"
			submitName="Selecteren"
			:resetValue="false"
			:root="true"
			:startDate="date"
			@apply="onDateApply"
		/>
	</div>
</template>

<script src="./FormulateDateSelector.js"></script>
